import styled from 'styled-components'

import { variables } from 'core/styles'

export const ErrorMessage = styled.p<{ color?: string; align?: string }>`
  font-size: 14px;
  color: ${(props) => props.color ?? variables.colorRed};
  text-align: ${(props) => props.align ?? 'left'};
`

export default ErrorMessage
